// frontend/src/components/CreditsChip.jsx
import React from "react";
import { useCredits } from "../state/credits";

export default function CreditsChip({ autoRefresh = true }) {
  const { credits, loading, refresh } = useCredits();

  // Initial load
  React.useEffect(() => {
    if (autoRefresh) refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refresh on focus/visibility
  React.useEffect(() => {
    if (!autoRefresh) return;
    const onFocus = () => refresh();
    const onVis = () => { if (document.visibilityState === "visible") refresh(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVis);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVis);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRefresh]);

  // NEW: Poll every 10 seconds when visible (catches payment completions)
  React.useEffect(() => {
    if (!autoRefresh) return;
    
    const interval = setInterval(() => {
      // Only refresh if tab is visible
      if (document.visibilityState === "visible") {
        refresh();
      }
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRefresh]);

  // NEW: Listen for app-wide credit update events
  React.useEffect(() => {
    if (!autoRefresh) return;

    const handleCreditUpdate = () => {
      console.log("[CreditsChip] Credit update event, refreshing...");
      refresh();
    };

    // Listen for the event that Profile.jsx broadcasts
    window.addEventListener("ab:credits", handleCreditUpdate);
    
    return () => {
      window.removeEventListener("ab:credits", handleCreditUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRefresh]);

  const value = Number.isFinite(Number(credits)) ? Number(credits) : 0;

  return (
    <div
      aria-label="Credits balance"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "6px 10px",
        border: "1px solid #e5e7eb",
        borderRadius: 999,
        background: "#fff",
        fontWeight: 700,
      }}
    >
      <span>Credits</span>
      <span
        style={{
          minWidth: 28,
          textAlign: "center",
          padding: "2px 8px",
          borderRadius: 999,
          background: "#111",
          color: "#fff",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {loading ? "—" : value}
      </span>
    </div>
  );
}